import { get, post } from '@/utils/axios';

export default {
  getUserSign(params) {
    return get('/wxLive/im/getUserSig', params);
  },
  // 根据手机号从爱学获取用户信息
  fetchUserInfo(params) {
    // const query = {
    //   method: 'get',
    //   url: 'api/user/Userinfobymobile',
    //   data: params
    // };
    // return post('/api/frontend/userservice/user/call-cloud-entry', query);
    return get('/wxLive/user/getUserInfoByMobile', params);
  },

  // 获取校本服务器外网地址
  fetchSchoolIps(params) {
    return get('/publicServer/serviceApi/getServerConfigByName', params);
  },

  // 发送验证码
  sendPhoneCode(params) {
    // const query = {
    //   method: 'post',
    //   url: 'api/loginapp/sendmcode',
    //   data: params
    // };
    // return post('/api/frontend/userservice/user/call-cloud-entry', query);
    return post('/wxLive/user/sendMobileCode', params);
  },

  // 手机号、密码登录
  login(params) {
    // const query = {
    //   method: 'post',
    //   url: 'api/userstep/login',
    //   data: params
    // };
    // return post('/api/frontend/userservice/user/call-cloud-entry', query);
    return post('/wxLive/user/login', params);
  },

  // 扫码分享手机号、密码登录
  loginCodePwd(params) {
    return post('/wxLive/user/login', params);
  },

  // 根据手机号获取用户信息
  getUserInfoByMobile(params) {
    return get('/wxLive/user/getUserInfoByMobile', params);
  },

  // 短信验证码登录
  codeLogin(params) {
    // const query = {
    //   method: 'post',
    //   url: 'api/loginapp/checkMobileOrEmailCode',
    //   data: params
    // };
    // return post('/api/frontend/userservice/user/call-cloud-entry', query);
    return post('/wxLive/user/checkMobileCode', params);
  },

  // 扫描分享短信验证码登录
  codeLoginShare(params) {
    return post('/wxLive/user/checkMobileCode', params);
  },

  // 获取校本服务器中当前用户的id
  fetchResUserId(params) {
    return get('/api/frontend/service/video/get-uid-by-mobile', params);
  }
};
